import React, { useState, useEffect, useRef } from 'react';
import FeeCommentCard from './FeeCommentCard';
import NewFeeCommentCard from './NewFeeCommentCard';
import {
    Row, Col,
    InputGroupText, Input, InputGroup, InputGroupAddon, FormGroup
} from 'reactstrap';
import { getFeeComments, saveFeeComment, addFeeComment, deleteFeeComment } from '../../API';

function Comments(props) {
    const [feeComments, setFeeComments] = useState([]);
    const [isLoadingComments, setIsLoadingComments] = useState(true);

    const [newComments, setNewComments] = useState([]);
    const [searchOptions, setSearchOptions] = useState(props.defaultSearch || {});
    const [searchTimeout, setSearchTimeout] = useState(false);
    const searchOptionsRef = useRef(searchOptions);
    const searchTimeoutRef = useRef(searchTimeout);
    searchOptionsRef.current = searchOptions;
    searchTimeoutRef.current = searchTimeout;

    useEffect(() => {
        const timeoutCommentSearch = async () => {
            setSearchTimeout(false);
            await search();
        };

        if (!searchTimeoutRef.current) {
            setSearchTimeout(true);
            setTimeout(timeoutCommentSearch, 500);
        }
    }, [searchOptions]);

    const search = async () => {
        setIsLoadingComments(true);

        const searchAPIResults = await getFeeComments(searchOptionsRef.current);
        setFeeComments(searchAPIResults.sort((a, b) => (a.commentDate < b.commentDate) ? 1 : ((b.commentDate < a.commentDate) ? -1 : 0)));

        setIsLoadingComments(false);
    };

    const getNewCommentId = () => {
        return newComments.map(u => u.feeCommentID).reduce((a, b) => (a > b) ? a : b, 0) + 1;
    };

    const addNewComment = () => {
        const tempId = getNewCommentId();
        const newComment = { feeCommentID: tempId, comment: '', feeId: props.feeId, commentDate: new Date() };
        setNewComments([newComment, ...newComments]);
    };

    const removeNewComment = (feeCommentId) => {
        const tempNewComments = [...newComments];
        const removeIndex = tempNewComments.findIndex(u => u.feeCommentID === feeCommentId);
        tempNewComments.splice(removeIndex, 1);
        setNewComments(tempNewComments);
    };

    const saveNewComment = async (newComment) => {
        const addableComment = {
            ...newComment,

        };
        delete addableComment.feeCommentID;

        const savedComment = await addFeeComment(addableComment);

        removeNewComment(newComment.feeCommentID);

        await search();
    };

    const saveComment = async (comment) => {
        await saveFeeComment(comment);

        await search();
    }

    const removeComment = async (feeCommentId) => {
        await deleteFeeComment(feeCommentId);

        await search();
    };

    const updateSearch = e => {
        setSearchOptions({
            ...searchOptions,
            [e.target.name]: e.target.value
        });
    };

    let feeCommentsJSX = (<div>No comments found.</div>);
    if (isLoadingComments)
        feeCommentsJSX = (<div>Loading...</div>);
    else if (feeComments.length > 0 || newComments.length > 0)
        feeCommentsJSX = (
            <div>
                {newComments?.map(u => (<NewFeeCommentCard key={u.feeCommentID} feeComment={u} cancel={removeNewComment} save={saveNewComment} />))}
                {feeComments?.map(u => (<FeeCommentCard key={u.feeCommentID} feeComment={u} delete={removeComment} save={saveComment} />))}
            </div>
        );

    return (
        <div>
            <Row xs={2} md={2} lg={3} xl={4} className="justify-content-between search-row">
                <Col>
                    <FormGroup>
                        <InputGroup className="tooltip-parent">
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><i className="fas fa-comment-dots"></i></InputGroupText>
                            </InputGroupAddon>
                            <Input type="text" name="comment" value={searchOptions.comment || ''} placeholder="Search Comments" onChange={updateSearch} />
                            <div className="tooltip-target">
                                Comment
                            </div>
                        </InputGroup>
                    </FormGroup>
                </Col>
                {window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                    <Col>
                        <div onClick={addNewComment} className="action-icon action-add float-right tooltip-parent">
                            <i className="fas fa-plus"></i>
                            <div className="tooltip-target">
                                Add New Comment
                        </div>
                        </div>
                    </Col>
                ) : null}
            </Row>
            <Row>
                <Col>
                    {feeCommentsJSX}
                </Col>
            </Row>
        </div>
    );
}

export default Comments;